import { Vue, Component, Prop, Inject } from 'vue-property-decorator';
import bodyComponent from '@/entities/report-insights/template-report/template-one/body-component';
import referenceComponent from '@/entities/report-insights/template-report/template-one/reference-component';
import vueCustomScrollbar from 'vue-custom-scrollbar';
import reportRelated from '@/entities/report-insights/report-related-peoples/report-related-people.vue';
import moment from 'moment';
import type { IBriefingPage, IResourceModel } from '@/shared/model/briefing-widget.model';
import { namespace } from 'vuex-class';
import { formatDateAgo } from '../../../util/date-util';
import { downloadFilePDFTopic, onErrorImageAvatar } from '@/util/common-util';
import BriefingService from '@/service/briefing.service';
import { BASE64_LOGO_ICON_DATA } from '@/util/base64-string-goover-favicon';
import {
  Document,
  Packer,
  Paragraph,
  TextRun,
  HeadingLevel,
  Alignment,
  ImageRun,
  PageBreak,
  TableOfContents,
  Table,
  TableRow,
  TableCell,
  WidthType,
  Styles,
  Border,
  BorderStyle,
  ExternalHyperlink,
  TabStopType,
} from 'docx';
import * as fs from 'fs';

const appStoreState = namespace('appStore');
const briefingStore = namespace('briefingStore');

@Component({
  computed: {
    moment() {
      return moment;
    },
  },
  methods: { formatDateAgo, onErrorImageAvatar },
  components: {
    'body-component': bodyComponent,
    'reference-component': referenceComponent,
    vueCustomScrollbar: vueCustomScrollbar,
    reportRelated,
  },
})
export default class TopicContent extends Vue {
  @Prop(Boolean) readonly loading: boolean | false;
  @Prop(Object) readonly topicDetail: any | undefined;
  @Prop(Array) readonly detailSocialBP: any | undefined;
  @Prop() readonly briefingPageId: any | false;
  @Prop(Number) readonly viewCount: number | 0;

  textFont = 'Noto Sans';
  subscribeStatus = '';
  isLoadingSubcribe = false;
  tempUserKey = JSON.parse(localStorage.getItem('localStorageUser')).id || '';

  @briefingStore.Getter
  public getSelectedResource!: IResourceModel;

  @briefingStore.Getter
  public getFeaturedPages!: IBriefingPage[];

  @briefingStore.Getter
  public getSocialPages!: IBriefingPage[];

  @appStoreState.Getter
  public isShowDetailTopic!: boolean;

  @briefingStore.Mutation
  public setFeaturedPages: (payload: IBriefingPage[]) => void;

  @briefingStore.Mutation
  public setSocialPages: (payload: IBriefingPage[]) => void;

  @Inject('briefingService')
  private briefingService: () => BriefingService;

  created() {
    this.$root.$on('downloadAsWord', this.downloadAsWord);
    this.$root.$on('downloadReportAsPDF', this.downloadTopicAsPDF);
    // this.subscribeStatus = this.detailSocialBP?.subscribeStatus;
  }
  //
  // destroyed() {
  //   this.$root.$off('downloadAsWord', this.downloadAsWord);
  //   this.$root.$off('downloadReportAsPDF', this.downloadReportAsPDF);
  // }

  public get userIdentity(): any {
    return this.$store.getters?.account
      ? this.$store.getters?.account
      : this.$store.getters?.userIdentity
      ? this.$store.getters?.userIdentity
      : JSON.parse(localStorage.getItem('localStorageUser'))
      ? JSON.parse(localStorage.getItem('localStorageUser'))
      : null;
  }

  imageStyle() {
    return {
      width: '100%',
      display: this.loading ? 'inline' : 'none',
      transition: 'all 1s',
      animation: this.loading ? 'fadeIn 2s linear' : 'none',
    };
  }

  toggleSubscribed() {
    if (this.detailSocialBP) {
      this.isLoadingSubcribe = true;
      const toggleStatus = this.detailSocialBP?.subscribeStatus === 'SUBSCRIBE' ? 'UN_SUBSCRIBE' : 'SUBSCRIBE';
      const subscribeCount = this.detailSocialBP?.subscribeCount + (this.detailSocialBP?.subscribeStatus === 'SUBSCRIBE' ? -1 : 1);
      this.briefingService()
        .updateSubscribeBriefingPage(this.detailSocialBP.bpId, toggleStatus, this.userIdentity)
        .then(res => {
          this.subscribeStatus = res?.data?.body?.body?.status;
          Vue.set(this.detailSocialBP, 'subscribeStatus', toggleStatus);
          Vue.set(this.detailSocialBP, 'subscribeCount', subscribeCount);
          /* update in store */
          switch (toggleStatus) {
            case 'SUBSCRIBE': {
              const featuredStore = this.getFeaturedPages.findIndex(e => e.bpId === this.detailSocialBP.bpId);
              if (featuredStore >= 0) {
                this.getFeaturedPages.splice(featuredStore, 1);
              }
              this.getSocialPages.unshift({
                ...this.detailSocialBP,
                subscribeStatus: toggleStatus,
                subscribeCount: subscribeCount,
              });
              break;
            }
            case 'UN_SUBSCRIBE': {
              const indexStore = this.getSocialPages.findIndex(e => e.bpId === this.detailSocialBP.bpId);
              if (indexStore >= 0) {
                this.getSocialPages.splice(indexStore, 1);
              }
              break;
            }
          }
          this.setFeaturedPages(this.getFeaturedPages);
          this.setSocialPages(this.getSocialPages);
        })
        .finally(() => {
          this.isLoadingSubcribe = false;
        });
    }
  }

  updateUserInformationActivity(like: boolean, dislike: boolean) {
    if (this.tempUserKey) {
      this.tempUserKey =
        this.userIdentity?.id || JSON.parse(localStorage.getItem('localStorageUser')).id || this.$store.getters?.userIdentity?.id;
    }
    this.briefingService().updateUserActivityInformation(
      'request ' + Math.ceil(Math.random() * 100),
      this.tempUserKey,
      null,
      this.getSelectedResource.docId,
      like,
      false,
      false,
      dislike
    );
  }

  async fetchImageFromS3(imageUrl) {
    const response = await fetch(imageUrl);
    if (!response.ok) {
      throw new Error('Failed to fetch image from S3');
    }
    const arrayBuffer = await response.arrayBuffer();
    return new Uint8Array(arrayBuffer); // Convert to Uint8Array
  }

  async downloadAsWord() {
    // const imageCoverBuffer = await this.fetchImageFromS3(this.topicDetail.coverImageUrl);
    // const imageCoverImageRun = new ImageRun({
    //   data: imageCoverBuffer,
    //   transformation: { width: 17, height: 12 },
    //   altText: {
    //     title: 'This is an ultimate title',
    //     description: 'This is an ultimate image',
    //     name: 'My Ultimate Image',
    //   },
    // });
    const base64Image = await this.imageToBase64(this.topicDetail.coverImageUrl);
    let imageTitle = null;
    if (typeof base64Image === 'string' && base64Image.startsWith('data:image/')) {
      imageTitle = new ImageRun({
        data: base64Image.split(',')[1],
        transformation: { width: 600, height: 600 },
        altText: {
          title: 'This is an ultimate title',
          description: 'This is an ultimate image',
          name: 'My Ultimate Image',
        },
      });
    }

    const gooverLogoImageRun = new ImageRun({
      data: BASE64_LOGO_ICON_DATA,
      transformation: { width: 18, height: 18 },
      altText: {
        title: 'This is an ultimate title',
        description: 'This is an ultimate image',
        name: 'My Ultimate Image',
      },
    });

    const doc = new Document({
      sections: [
        {
          children: [
            new Paragraph({
              alignment: 'center',
              children: [
                new TextRun({
                  text: this.topicDetail.topicTitle,
                  size: 40,
                  color: '000000',
                  bold: true,
                  font: this.textFont,
                }),
              ],
            }),
            new Paragraph({
              alignment: 'left',
              tabStops: [
                //   {
                //     type: TabStopType.LEFT, // Tab for logo (left-aligned)
                //     position: 0, // Logo at the start
                //   },
                //   {
                //     type: TabStopType.CENTER, // Tab for title (center-aligned)
                //     position: 3000, // Adjust this value based on your document width
                //   },
                {
                  type: TabStopType.RIGHT, // Tab for date (right-aligned)
                  position: 9000, // Adjust based on your document width
                },
              ],
              children: [
                gooverLogoImageRun,
                new TextRun({
                  text: 'Summary',
                  size: 20,
                  color: '000000',
                  bold: true,
                  font: this.textFont,
                }),
                new TextRun({
                  text: '\t',
                  font: this.textFont,
                }),
                new TextRun({
                  text: moment.utc(this.topicDetail.publishedDate).local().format('YYYY-MM-DD HH:mm'),
                  size: 20,
                  color: '000000',
                  bold: true,
                  font: this.textFont,
                }),
              ],
              spacing: {
                before: 200, // Space before the paragraph in twips (1 twip = 1/20 pt)
                after: 350, // Space after the paragraph in twips
              },
            }),
            new Paragraph({
              border: {
                top: {
                  style: BorderStyle.SINGLE,
                  size: 6,
                  space: 0,
                  color: '000000',
                },
              },
            }),
            imageTitle ? new Paragraph({ children: [imageTitle] }) : new Paragraph({ children: [new TextRun({ text: '' })] }),
            ...this.topicDetail.topicContent.flatMap(topicContent => [
              new Paragraph({
                children: [
                  new TextRun({
                    text: topicContent,
                    size: 25,
                    color: '000000',
                    bold: true,
                    font: this.textFont,
                  }),
                ],
                spacing: {
                  after: 0,
                  before: 100,
                  line: 240 * 0.8,
                },
              }),
            ]),
            new Paragraph({
              alignment: 'left',
              children: [
                new TextRun({
                  text: 'Subtopic',
                  size: 30,
                  color: '000000',
                  bold: true,
                  font: this.textFont,
                }),
              ],
              spacing: {
                before: 100, // Space after the paragraph in twips
                after: 100, // Space after the paragraph in twips
              },
            }),
            ...this.topicDetail.subTopics.flatMap(subTopics => [
              new Paragraph({
                alignment: 'left',
                tabStops: [
                  {
                    type: TabStopType.LEFT, // Tab for date (right-aligned)
                    position: 300, // Adjust based on your document width
                  },
                ],
                children: [
                  // new TextRun({
                  //   text: '\t',
                  //   font: this.textFont,
                  // }),
                  new TextRun({
                    text: subTopics.subTopicTitle,
                    size: 30,
                    color: '000000',
                    bold: true,
                    font: this.textFont,
                  }),
                ],
                spacing: {
                  before: 200,
                  after: 100, // Space after the paragraph in twips
                  line: 240 * 0.8,
                },
              }),
              ...subTopics.subTopicContent.flatMap(
                subTopicContent =>
                  new Paragraph({
                    alignment: 'left',
                    // tabStops: [
                    //   {
                    //     type: TabStopType.LEFT,
                    //     position: 400,
                    //   },
                    // ],
                    children: [
                      // new TextRun({
                      //   text: '\t',
                      //   font: this.textFont,
                      // }),
                      new TextRun({
                        text: subTopicContent,
                        size: 20,
                        color: '000000',
                        bold: true,
                        font: this.textFont,
                      }),
                    ],
                    spacing: {
                      after: 0,
                      before: 70,
                      line: 240 * 0.8,
                    },
                  })
              ),
              new Paragraph({
                alignment: 'left',
                tabStops: [
                  {
                    type: TabStopType.LEFT,
                    position: 400,
                  },
                ],
                children: [
                  // new TextRun({
                  //   text: '\t',
                  //   font: this.textFont,
                  // }),
                  new TextRun({
                    text: 'References',
                    size: 25,
                    color: '000000',
                    bold: true,
                    font: this.textFont,
                  }),
                ],
                spacing: {
                  after: 100, // Space after the paragraph in twips
                  before: 70, // Space after the paragraph in twips
                },
              }),
              ...subTopics.subTopicDocList.flatMap(
                subTopicDocList =>
                  new Paragraph({
                    alignment: 'left',
                    tabStops: [
                      {
                        type: TabStopType.LEFT,
                        position: 400,
                      },
                    ],
                    children: [
                      // new TextRun({
                      //   text: '\t',
                      //   font: this.textFont,
                      // }),
                      new ExternalHyperlink({
                        children: [
                          new TextRun({
                            text: subTopicDocList.docTitle,
                            style: 'Hyperlink',
                            font: this.textFont,
                          }),
                        ],
                        link: subTopicDocList.docUrl,
                      }),
                      new TextRun('.'),
                    ],
                    spacing: {
                      line: 240 * 0.8,
                    },
                  })
              ),
            ]),
          ],
        },
      ],
    });

    const blob = await Packer.toBlob(doc);
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    const filename = this.topicDetail?.topicTitle || 'document';
    link.download = filename + '.docx';
    link.click();
  }
  getImgBase64(elementId) {
    const img = document.getElementById(elementId);
    console.log('found element', img);
    // Create a canvas element
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');

    // Set canvas dimensions to match the image
    // @ts-ignore
    canvas.width = img.width;
    // @ts-ignore
    canvas.height = img.height;

    // Draw the image on the canvas
    // @ts-ignore
    ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

    // Get the base64 string from the canvas
    const base64String = canvas.toDataURL('image/jpeg'); // or 'image/png'

    // Output or use the base64 string
    console.log('base64String', base64String);
    return base64String;
  }

  // async imageToBase64(image){
  //   const response = await fetch(image);
  //   if (!response.ok) {
  //     throw new Error("Network response was not ok");
  //   }
  //   const reader = new FileReader();
  //   reader.onloadend = async () => {
  //     if (typeof reader.result === 'string') {
  //       const base64Image = reader.result.split(',')[1];
  //       return base64Image;
  //     }
  //
  // }

  async imageToBase64(url) {
    try {
      const response = await fetch(url);
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }

      const blob = await response.blob();
      const reader = new FileReader();

      return new Promise((resolve, reject) => {
        reader.onloadend = () => {
          resolve(reader.result); // Resolve with the Base64 string
        };
        reader.onerror = reject; // Handle any errors during reading
        reader.readAsDataURL(blob); // Read the Blob as Data URL
      });
    } catch (error) {
      console.error('Error encoding image to Base64:', error);
    }
  }

  downloadTopicAsPDF() {
    try {
      const image = document.getElementById('topicImage');
      const rect = image.getBoundingClientRect();
      const renderedWidth = rect.width;
      const renderedHeight = rect.height;
      // console.log('rect.width ', renderedWidth,' : rect.height ', renderedHeight)
      downloadFilePDFTopic(this.topicDetail, renderedWidth, renderedHeight);
    } catch (e) {
      console.log('Download failed pdf by custom text with error: ', e);
      // this.downloadPdfByImage();
    }
  }
}
